import { useEffect } from 'react'

export const ScrollToTop = () => {
  const { location } = window

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return null
}
